import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

type FlexAlignType = 'stretch' | 'start' | 'center' | 'end' | 'baseline';
type FlexJustifyType =
  | 'normal'
  | 'space-around'
  | 'space-between'
  | 'space-evenly'
  | 'center'
  | 'stretch'
  | 'end';

export type FlexProps = PropsWithChildren<{
  align?: FlexAlignType;
  justify?: FlexJustifyType;
  wrap?: boolean;
  vertical?: boolean;
  className?: string;
  fullWidth?: boolean;
  fullHeight?: boolean;
}>;

export const Flex = ({
  align = 'start',
  justify = 'normal',
  wrap = false,
  vertical = false,
  className,
  children,
  fullWidth = false,
  fullHeight = false,
}: FlexProps) => {
  const controlClasses = {
    [`wk-flex--align-${align}`]: true,
    [`wk-flex--justify-${justify}`]: true,
    'wk-flex--vertical': vertical,
    'wk-flex--wrap': wrap,
    'wk-flex--full-width': fullWidth,
    'wk-flex--full-height': fullHeight,
  };

  return (
    <>
      <div className={clsx('wk-flex', className, controlClasses)}>
        {children}
      </div>
      <style jsx>{`
        .wk-flex {
          display: flex;
        }
        .wk-flex--vertical {
          flex-direction: column;
        }
        .wk-flex--wrap {
          flex-wrap: wrap;
        }
        .wk-flex--align-stretch {
          align-items: stretch;
        }
        .wk-flex--align-start {
          align-items: flex-start;
        }
        .wk-flex--align-center {
          align-items: center;
        }
        .wk-flex--align-end {
          align-items: flex-end;
        }
        .wk-flex--align-baseline {
          align-items: baseline;
        }
        .wk-flex--justify-normal {
          justify-content: normal;
        }
        .wk-flex--justify-space-around {
          justify-content: space-around;
        }
        .wk-flex--justify-space-between {
          justify-content: space-between;
        }
        .wk-flex--justify-space-evenly {
          justify-content: space-evenly;
        }
        .wk-flex--justify-center {
          justify-content: center;
        }
        .wk-flex--justify-stretch {
          justify-content: stretch;
        }
        .wk-flex--justify-end {
          justify-content: flex-end;
        }
        .wk-flex--full-width {
          width: 100%;
        }
        .wk-flex--full-height {
          height: 100%;
        }
      `}</style>
    </>
  );
};
